module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpys_one.c0c77ed5.png";